// extracted by mini-css-extract-plugin
export default {"cardContainer":"AllProjects_cardContainer__arg6M","cardTitle":"AllProjects_cardTitle__5+2Yh","cardDes":"AllProjects_cardDes__JKGgj"};